import {ref} from 'vue'

export function useTooltip(tooltipWidth, margin = 5) {

  // Tooltip
  const tooltipIsOn = ref(false)
  const tooltipDelayed = ref(null);
  const keepTooltips = ref([]);
  const forewardmostTooltip = ref(null);
  const dragging = ref(null);

  let tooltip = ref({
    position: {left: '', top: ''},
    header: '',
    content: ''
  })

  function showTooltip(event, showOnLeft, showOnBottom, deviateX = 0, deviateY = 0, tooltipWidthCustom = 0) {
    if (dragging.value) return
    tooltipDelayed.value = setTimeout(() => {
      // Position
      const width = tooltipWidthCustom > 0 ? tooltipWidthCustom : tooltipWidth
      const position = getTooltipPosition(event, showOnLeft, showOnBottom, deviateX, deviateY, width)
      tooltip.value.position.width = position.width
      tooltip.value.position.left = position.left
      tooltip.value.position.top = position.top
      // header
      tooltip.value.header = event.target.attributes['data-tooltipHeader']?.value
      // content
      tooltip.value.content = event.target.attributes['data-tooltipContent']?.value
      tooltipIsOn.value = true
    }, 400);
  }

  function getTooltipPosition(event, showOnLeft, showOnBottom, deviateX = 0, deviateY = 0, width) {
    const x = event.target.getBoundingClientRect().x
    const y = event.target.getBoundingClientRect().y
    const widthOfDiv = event.target.getBoundingClientRect().width
    const tooltipPosition = {left: '', top: '', width: width + 'px'};
    // Position
    tooltipPosition.left = x + widthOfDiv + margin + deviateX + 'px'
    tooltipPosition.top = y + 'px'
    
    if (showOnLeft) {
      tooltipPosition.left = x - width - margin + deviateX + 'px'
    }
    if (showOnBottom) {
      tooltipPosition.top = y + deviateY + 'px'
    }
    return tooltipPosition;
  }

  function keepTooltipOpen (event, showOnLeft, showOnBottom, deviateX, deviateY, header, id, content, tooltipWidthCustom = 0) {
    const existingTooltipIndex = keepTooltips.value.findIndex(t => t.id === id)
    if (existingTooltipIndex >= 0) {
      keepTooltips.value.splice(existingTooltipIndex, 1)
      forewardmostTooltip.value = null
      return
    }
    const width = tooltipWidthCustom > 0 ? tooltipWidthCustom : tooltipWidth
    const position = getTooltipPosition(event, showOnLeft, showOnBottom, deviateX, deviateY, width)
    const keptTooltip = {
      id: id,
      header: header,
      content: event.target.attributes['data-tooltipContent']?.value || content || '',
      left: position.left,
      top: position.top,
      width: position.width,
    }
    keepTooltips.value.push(keptTooltip)
    forewardmostTooltip.value = id
    closeTooltip()
  }

  function closeTooltip() {
    clearTimeout(tooltipDelayed.value)
    tooltipDelayed.value = null
    tooltipIsOn.value = false
    tooltip.value.position.left = null
    tooltip.value.position.top = null
    tooltip.value.content = ''
    tooltip.value.header = ''
  }

  function closeKeptTooltip (index) {
    keepTooltips.value.splice(index, 1)
    forewardmostTooltip.value = null
    dragging.value = null
  }

  // function startMoveTooltip (id, index) {
  function startMoveTooltip (event, id, index) {
    if (dragging.value) {
      return
    }

    dragging.value = keepTooltips.value[index]
    dragging.value.index = index
    forewardmostTooltip.value = id

    keepTooltips.value[index].leftOffset = document.getElementById('tooltip-' + id).offsetLeft - event.clientX
    keepTooltips.value[index].topOffset = document.getElementById('tooltip-' + id).offsetTop - event.clientY
    keepTooltips.value[index].position = {}
  }

  // function moveTooltip () {
  function moveTooltip (event) {
    if (dragging.value) {
      document.getElementById('tooltip-' + dragging.value.id).style.left = event.clientX + keepTooltips.value[dragging.value.index].leftOffset + 'px'
      document.getElementById('tooltip-' + dragging.value.id).style.top = event.clientY + keepTooltips.value[dragging.value.index].topOffset + 'px'
      document.getElementById('tooltip-' + dragging.value.id).style.cursor = 'grab'
    }
  }

  function dropTooltip () {
    if (dragging.value) {
      keepTooltips.value[dragging.value.index].left = document.getElementById('tooltip-' + dragging.value.id).style.left
      keepTooltips.value[dragging.value.index].top = document.getElementById('tooltip-' + dragging.value.id).style.top
      document.getElementById('tooltip-' + dragging.value.id).style.cursor = 'unset'
      dragging.value = null
    }
  }

  return {
    tooltipIsOn,
    tooltip,
    keepTooltips,
    forewardmostTooltip,
    showTooltip,
    getTooltipPosition,
    keepTooltipOpen,
    closeTooltip,
    closeKeptTooltip,
    startMoveTooltip,
    moveTooltip,
    dropTooltip,
  }
}
